import { generateText as tiptapGenerateText } from '@tiptap/react'

import type { FormattedText } from '@mntn-dev/utility-types'

import { getExtensionKit } from '../extensions/extension-kit.ts'
import { getEditorContent } from './get-editor-content.ts'

export const generateText = (json: FormattedText) => {
  const text = tiptapGenerateText(json, getExtensionKit({ placeholder: '' }))
  return text
}

export const generateTextFromJsonString = (jsonString: string) => {
  const json = getEditorContent(jsonString)
  return generateText(json)
}
